export default "__VITE_ASSET__D$Jrrq1F__"